import React from 'react';
import { Box, Typography } from '@mui/material';
import CountryFlag from 'react-country-flag';
import lookup from 'country-code-lookup';

/**
 * Custom flag image URLs for football nations not in the ISO 3166-1 standard.
 * Uses Wikimedia Commons SVGs (public domain / freely licensed).
 */
export const CUSTOM_FLAGS = {
  'Scotland':         'https://upload.wikimedia.org/wikipedia/commons/1/10/Flag_of_Scotland.svg',
  'England':          'https://upload.wikimedia.org/wikipedia/en/b/be/Flag_of_England.svg',
  'Wales':            'https://upload.wikimedia.org/wikipedia/commons/d/dc/Flag_of_Wales.svg',
  'Northern Ireland': 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Flag_of_Ulster.svg/1200px-Flag_of_Ulster.svg.png',
  'Kosovo':           'https://upload.wikimedia.org/wikipedia/commons/1/1f/Flag_of_Kosovo.svg',
  'Palestine':        'https://upload.wikimedia.org/wikipedia/commons/0/00/Flag_of_Palestine.svg',
  'Catalonia':        'https://upload.wikimedia.org/wikipedia/commons/c/ce/Flag_of_Catalonia.svg',
  'Basque Country':   'https://upload.wikimedia.org/wikipedia/commons/2/2d/Flag_of_the_Basque_Country.svg',
  'Gibraltar':        null, // covered by ISO (GI)
  'Ivory Coast':      'https://upload.wikimedia.org/wikipedia/commons/f/fe/Flag_of_C%C3%B4te_d%27Ivoire.svg',
};

export function TeamCrest({ name, size = 62 }) {
  const cc = lookup.byCountry(name);
  const customFlag = name ? CUSTOM_FLAGS[name] : undefined;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.25, flex: 1, minWidth: 0 }}>
      <Box sx={{
        width: size, height: size, borderRadius: '50%', overflow: 'hidden', bgcolor: '#222',
        boxShadow: '0 0 0 2px rgba(255,255,255,0.15), 0 6px 16px rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', flex: '0 0 auto',
      }}>
        {cc ? (
          <CountryFlag countryCode={cc.iso2} svg style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : customFlag ? (
          <img src={customFlag} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <Typography sx={{ fontWeight: 700, color: '#fff', fontSize: size * 0.28 }}>
            {(name || '').slice(0, 2).toUpperCase()}
          </Typography>
        )}
      </Box>
      <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#fff', textAlign: 'center', textWrap: 'balance' }}>
        {name}
      </Typography>
    </Box>
  );
}
